import { Box, SxProps } from "@mui/material";
import { memo } from "react";

export const MinimalButton = memo(
  ({
    children,
    onClick,
    sx,
    isLoading = false,
    backgroundColor = "action.selected",
  }: {
    children: React.ReactNode;
    onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
    sx?: SxProps;
    isSaved?: boolean;
    isLoading?: boolean;
    backgroundColor?: string;
  }) => {
    return (
      <Box
        onMouseDown={(event) => {
          event.preventDefault();
        }}
        onClick={(event) => {
          if (isLoading) {
            return;
          }
          // Find the closest input field and blur it before handling save
          // For when user didn't even blur input field before clicking save
          const inputElement = document.activeElement as HTMLInputElement;
          if (inputElement && inputElement.tagName === "INPUT") {
            inputElement.blur(); // Triggers onBlur before handleSave
          }
          event.stopPropagation();

          onClick(event);
        }}
        sx={{
          cursor: isLoading ? "not-allowed" : "pointer",
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: isLoading ? "action.selected" : backgroundColor,
          "&:hover": {
            backgroundColor: isLoading ? "action.selected" : "action.hover",
          },
          mt: 0.25,
          ...sx,
        }}
      >
        {children}
      </Box>
    );
  }
);
